import { Application } from '../../../common/types/dataLayer';
import { Logger } from '../../../common/types/loggerTypes';
import { DataLayerItem } from '../types';
import AbstractDataLayerManager from './abstractDataLayerManager';

export type DataLayerAvailablePlatforms = Record<DataLayerPlatform, string>;
export enum DataLayerPlatform {
    NONE = 'NONE',
    MOBILE = 'MOBILE',
    DESKTOP = 'DESKTOP',
}

const platforms: DataLayerAvailablePlatforms = {
    NONE: '',
    DESKTOP: 'desktop_web',
    MOBILE: 'mobile_web',
};

export const initialDataLayerItem = (platform: DataLayerPlatform): DataLayerItem => ({
    'app.name': Application.BELLA,
    platform: platforms[platform],
    /* eslint-disable-next-line @typescript-eslint/camelcase, camelcase */
    is_bella_user: true,
});

class ServerDataLayerManager extends AbstractDataLayerManager {
    private dataLayer: DataLayerItem[] = [];

    protected getRawDataLayer(): DataLayerItem[] {
        return this.dataLayer;
    }

    public constructor(logger: Logger) {
        super(logger);
        this.initUserSession();
    }

    public setPlatform(platform: DataLayerPlatform): this {
        this.dataLayer = [initialDataLayerItem(platform)];
        return this;
    }

    public initUserSession(): this {
        this.userSessionDidInit = true;
        return this;
    }
}

export default ServerDataLayerManager;
